export default __webpack_public_path__ + "static/media/html5.ed7faa62.svg";